import { useEffect } from 'react';

export function useScrollAnimation() {
  useEffect(() => {
    const style = document.createElement('style');
    style.textContent = `
      [data-animate] {
        opacity: 0;
        will-change: opacity, transform;
        transition: opacity 0.8s ease, transform 0.8s ease;
      }
      [data-animate="fade-up"],
      [data-animate] {
        transform: translateY(42px);
      }
      [data-animate="fade-left"] {
        transform: translateX(42px);
      }
      [data-animate="fade-right"] {
        transform: translateX(-42px);
      }
      [data-animate="scale-up"] {
        transform: scale(1);
      }
      [data-animate].is-visible {
        opacity: 1;
        transform: none;
      }
    `;
    document.head.appendChild(style);

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          const el = entry.target;
          const delay = el.dataset.delay ? parseInt(el.dataset.delay) : 0;
          setTimeout(() => el.classList.add('is-visible'), delay);
          observer.unobserve(el); // fire once only
        });
      },
      { threshold: 0.12 }
    );

    document.querySelectorAll('[data-animate]').forEach((el) => observer.observe(el));

    return () => {
      observer.disconnect();
      document.head.removeChild(style);
    };
  }, []);
}